import styled from 'styled-components';

export const OfferProgress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  .bannerWrapper {
    margin-top: 15px;
  }

  @media (min-width: 1024px) {
    height: 45%;
    width: 45%;
    margin: 0 auto;

    .featureImages {
      height: 50%;
      width: 50%;
      margin: 0 auto;
    }
  }
`;

export const RadioButtons = styled.div`
  display: flex;
  justify-content: space-around;
  position: relative;
  background: linear-gradient(
    to bottom,
    rgba(251, 212, 106, 0.4) 0%,
    rgba(251, 212, 106, 0.35) 50%,
    rgba(251, 212, 106, 0.3) 100%
  );
  .radioButton {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: 100%;
  }

  .horizontalLine {
    width: 45.5%;
    position: absolute;
    top: 11.5%;
    left: 27.5%;
    right: 0;
    height: 2px;
    background-color: ${(props) =>
      props.freebieUnlocked ? '#ef4e5e' : 'rgba(0,0,0,0.3)'};
    z-index: -1;
    transition: background 0.2s ease-in-out;
  }

  p {
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    line-height: 1.42;
    margin: 10px;
    width: 70%;
  }

  .active {
    color: #ef4e5e;
  }

  .inactive {
    color: #909090;
  }
`;
